import styles from "./Mascot.module.css";

interface MascotProps {
  size?: number;
  wave?: boolean;
}

export default function Mascot({ size = 170, wave = false }: MascotProps) {
  return (
    <svg
      className={wave ? styles.wave : undefined}
      width={size}
      height={(size * 200) / 170}
      viewBox="0 0 170 200"
      aria-hidden="true"
    >
      <rect x="28" y="62" width="24" height="76" rx="12" fill="#FFD27A" stroke="#1E1B4B" strokeWidth="3" />
      <rect x="56" y="34" width="24" height="100" rx="12" fill="#FFD27A" stroke="#1E1B4B" strokeWidth="3" />
      <rect x="84" y="30" width="24" height="104" rx="12" fill="#FFD27A" stroke="#1E1B4B" strokeWidth="3" />
      <rect x="112" y="48" width="24" height="88" rx="12" fill="#FFD27A" stroke="#1E1B4B" strokeWidth="3" />
      <rect x="24" y="100" width="118" height="92" rx="40" fill="#FFB020" stroke="#1E1B4B" strokeWidth="3" />
      <circle cx="66" cy="140" r="6" fill="#1E1B4B" />
      <circle cx="102" cy="140" r="6" fill="#1E1B4B" />
      <path d="M70 162q14 12 28 0" fill="none" stroke="#1E1B4B" strokeWidth="3.5" strokeLinecap="round" />
      <circle cx="52" cy="158" r="7" fill="#FB7185" opacity="0.7" />
      <circle cx="116" cy="158" r="7" fill="#FB7185" opacity="0.7" />
    </svg>
  );
}
